(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FrontEndModules", [], factory);
	else if(typeof exports === 'object')
		exports["FrontEndModules"] = factory();
	else
		root["FrontEndModules"] = factory();
})(window, function() {
return 